import React, { useEffect } from "react";
import { FormElements } from "../../../../../../../../shared/bootstrap/form/FormElements";
import FormGroup from "../../../../../../../../shared/bootstrap/form/form-group/FormGroup";
import InputCustom from "../../../../../../../../shared/bootstrap/form/input/InputCustom";
import { useLanguageForShared } from "../../../../../../../../shared/utils/languages/useLanguageForShared";
import ConcentratorFlowTypeSelector from "./ConcentratorFlowTypeSelector";
import { copyObject } from "../../../../../../../../shared/utils/objUtils";

const ConcentratorCoreTransportable = ({ dataForm, changeValue, errors, isSubmit, setData, prescriptionTitle = "Trasportabile" }) => {
  const { t } = useLanguageForShared();

  const flowType = dataForm?.["transportable.flowType"] ?? dataForm?.transportable?.flowType ?? "";
  const isPulsed = flowType === "pulsed";

  useEffect(() => {
    const needsCleanup =
      (dataForm?.pulsedFlow !== undefined) ||
      (!isPulsed && dataForm?.pulsedFlowSettings !== undefined);
    if (needsCleanup && setData) {
      const copy = copyObject(dataForm);
      delete copy.pulsedFlow;
      if (!isPulsed) {
        delete copy.pulsedFlowSettings;
      }
      setData(copy);
    }
  }, [isPulsed, dataForm?.pulsedFlow]);

  const formStructurePrescription = [
    {
      name: "transportable.flowRest",
      type: "input",
      label: isPulsed ? `${t("prescription.template.levelRest")}*` : `${t("prescription.template.flowRest")}*`,
      dataElement: {
        placeholder: t("prescription.template.flowRest_placeholder"),
        type: "text"
      },
      col: { xs: "8", sm: "8", lg: "3", xl: "3" }
    },
    {
      name: "transportable.flowRestHourDie",
      type: "input",
      label: `${t("prescription.template.hourDie")}*`,
      dataElement: {
        placeholder: t("prescription.template.hourDie_placeholder"),
        type: "text"
      },
      col: { xs: "4", sm: "4", lg: "1", xl: "1" },
      display: { form: "me-lg-5" }
    },
    {
      name: "transportable.underStressFlow",
      type: "input",
      label: isPulsed ? `${t("prescription.template.levelUnderStress")}*` : `${t("prescription.template.underStressFlow")}*`,
      dataElement: {
        placeholder: t("prescription.template.underStressFlow_placeholder"),
        type: "text"
      },
      col: { xs: "6", sm: "6", lg: "3", xl: "3" }
    },
    {
      name: "transportable.underStressFlowHourDie",
      type: "input",
      label: `${t("prescription.template.hourDie")}*`,
      dataElement: {
        placeholder: t("prescription.template.hourDie_placeholder"),
        type: "text"
      },
      col: { xs: "6", sm: "6", lg: "1", xl: "1" },
      display: { form: "me-lg-5" }
    },
    {
      name: "transportable.nightFlow",
      type: "input",
      label: isPulsed ? `${t("prescription.template.levelNight")}*` : `${t("prescription.template.nightFlow")}*`,
      dataElement: {
        placeholder: t("prescription.template.nightFlow_placeholder"),
        type: "text"
      },
      col: { xs: "6", sm: "6", lg: "3", xl: "3" }
    },
    {
      name: "transportable.nightFlowHourDie",
      type: "input",
      label: `${t("prescription.template.hourDie")}*`,
      dataElement: {
        placeholder: t("prescription.template.hourDie_placeholder"),
        type: "text"
      },
      col: { xs: "6", sm: "6", lg: "1", xl: "1" },
      display: { form: "me-lg-5" }
    }
  ];

  const getValue = (val) => {
    if (!val) return 0;
    const normalized = String(val).replace(",", ".");
    const parsed = parseFloat(normalized);
    return isNaN(parsed) ? 0 : parsed;
  };

  const getFieldValue = (flatKey, nestedKey) => dataForm?.[flatKey] ?? dataForm?.transportable?.[nestedKey];

  const sum =
    getValue(getFieldValue("transportable.nightFlowHourDie", "nightFlowHourDie")) +
    getValue(getFieldValue("transportable.underStressFlowHourDie", "underStressFlowHourDie")) +
    getValue(getFieldValue("transportable.flowRestHourDie", "flowRestHourDie"));

  return (
    <>
      <p className={"title-paragraph"} style={{ fontWeight: "bold", marginBottom: "1.5rem", marginTop: "2rem" }}>{t("sg.prescription")} | {prescriptionTitle}</p>
      <FormElements
        structure={formStructurePrescription}
        dataForm={dataForm}
        changeValue={changeValue}
        isSubmit={isSubmit}
        errors={errors}
      />

      <div className="row">
        <div className="col-sm-12 col-lg-3">
          <FormGroup
            label={{ label: t("prescription.template.check24h.label") }}
            error={{
              isVisible: sum > 24,
              message: t("prescription.template.check24h.error")
            }}
          >
            <InputCustom
              type={"text"}
              name={"transportable.check24h"}
              error={sum > 24}
              value={sum}
              readOnly={true}
              style={{ cursor: "default", fontWeight: "bold" }}
            />
          </FormGroup>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12 col-lg-6">
          <ConcentratorFlowTypeSelector
            name={"transportable.flowType"}
            value={flowType}
            changeValue={changeValue}
            isSubmit={isSubmit}
          />
        </div>
        {isPulsed && (
          <div className="col-sm-12 col-lg-6">
            <FormGroup label={{ label: t("prescription.template.pulsedFlowSettings.label") }}>
              <InputCustom
                type={"text"}
                name={"pulsedFlowSettings"}
                value={dataForm?.["pulsedFlowSettings"] ?? ""}
                placeholder={t("prescription.template.pulsedFlowSettings.placeholder")}
                changeValue={(val) => changeValue({ name: "pulsedFlowSettings", value: val })}
              />
            </FormGroup>
          </div>
        )}
      </div>
    </>
  );
};

export default ConcentratorCoreTransportable;
